import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RecipeService {

  private url = environment.api;

  constructor(
      private http: HttpClient,
    ) { }

  addRecipe(productRecipeId: number, productId: number, quantity: number) {
    const body = { 
      productRecipeId: productRecipeId,
      productId: productId,
      quantity: quantity 
    };
    return this.http.post(this.url + `api/erp/recipes/`, body);
  }

  getRecipes() {
    return this.http.get(this.url + "api/erp/recipes/all");
  }

  getRecipeById(id: number) {
    return this.http.get(this.url + `api/erp/recipes/${id}`);
  }

  updateRecipe(id: number, quantity: number) {
    const body = { 
      id: id,
      quantity: quantity 
    };
    return this.http.put(this.url + `api/erp/recipes/`, body);
  }

  deleteRecipeById(id: number) {
    return this.http.delete(this.url + `api/erp/recipes/${id}`);
  }
}
